import React, { useState } from "react";
import { Info } from "@phosphor-icons/react";
import { useGov } from "@/hooks/governance";
import { govStatusTone } from "@/lib/governance";
import { Badge, HashCell } from "@/components/primitives";
import { Table } from "@/components/Table";
import { GovPageShell, GovError, GovPager, useGovNav } from "@/components/governance/GovShell";

const PAGE = 25;

export const Withdrawals = ({ meta }) => {
  const navigate = useGovNav();
  const [page, setPage] = useState(1);
  const { data, error, loading, refetch } = useGov("/governance/proposals", {
    params: { count: PAGE, page, order: "desc", type: "treasury_withdrawals" },
  });
  const rows = Array.isArray(data) ? data : [];

  const columns = [
    {
      key: "action",
      label: "Governance Action",
      render: (r) => (
        <button
          type="button"
          data-testid={`withdrawal-row-${r.tx_hash}-${r.cert_index}`}
          onClick={() => navigate(`/governance/proposals/${r.tx_hash}/${r.cert_index}`)}
          className="text-left text-foreground hover:text-primary underline decoration-dotted decoration-border underline-offset-2 transition-colors mono text-[12px]"
        >
          {(r.gov_action_id || `${r.tx_hash}#${r.cert_index}`).slice(0, 22)}…
        </button>
      ),
    },
    { key: "status", label: "Status", render: (r) => <Badge tone={govStatusTone(r.status)}>{r.status}</Badge> },
    { key: "sub", label: "Submitted", align: "right", render: (r) => <span className="text-muted-foreground">epoch {r.submitted_epoch ?? "—"}</span> },
    { key: "out", label: "Outcome", align: "right", render: (r) => <span className="text-muted-foreground">{r.enacted_epoch ? `enacted ${r.enacted_epoch}` : r.expired_epoch ? `expired ${r.expired_epoch}` : r.dropped_epoch ? `dropped ${r.dropped_epoch}` : "—"}</span> },
  ];

  return (
    <GovPageShell crumbs={meta.crumbs} title={meta.title} subtitle="Every treasury-withdrawal governance action. Open one to see recipients and amounts.">
      <div className="flex items-start gap-2 text-[12px] text-muted-foreground border border-primary/15 bg-primary/5 rounded-lg px-3 py-2.5 mono">
        <Info size={15} className="mt-0.5 shrink-0 text-primary/70" />
        <span>Requested amounts and recipient breakdowns are shown on each action's detail page under the Withdrawals tab.</span>
      </div>
      {error ? (
        <GovError error={error} onRetry={refetch} />
      ) : (
        <>
          <Table columns={columns} rows={rows} loading={loading} skeletonRows={10} empty="No treasury-withdrawal actions found." />
          <GovPager page={page} onPage={setPage} hasNext={rows.length === PAGE} loading={loading} />
        </>
      )}
    </GovPageShell>
  );
};
